export default function useUserConfigTable() {
  return [
    // { label: "Data inserimento", 
    //   key: "data_inserimento",
    //   width: "80px",
    //   formatter: (value) => {
    //     if (!value) return '';
    //     const date = new Date(value);
    //     const pad = (n) => n.toString().padStart(2, '0');
    //     const giorno = pad(date.getDate());
    //     const mese = pad(date.getMonth() + 1);
    //     const anno = date.getFullYear();
    //     // const ore = pad(date.getHours());
    //     // const minuti = pad(date.getMinutes());
    //     //return `${giorno}/${mese}/${anno} ore ${ore}:${minuti}`;
    //     return `${giorno}/${mese}/${anno}`;
    //   }
    // },
    // { label: "Data ultima iscrizione", 
    //   key: "ultima_data_iscrizione_corso",
    //   width: "100px",
    //   formatter: (value) => {
    //     if (!value) return '';
    //     const date = new Date(value);
    //     const pad = (n) => n.toString().padStart(2, '0');
    //     const giorno = pad(date.getDate());
    //     const mese = pad(date.getMonth() + 1);
    //     const anno = date.getFullYear();
    //     // const ore = pad(date.getHours());
    //     // const minuti = pad(date.getMinutes());
    //     //return `${giorno}/${mese}/${anno} ore ${ore}:${minuti}`;
    //     return `${giorno}/${mese}/${anno}`;
    //   }
    // },
    { label: "Cognome", key: "cognome", width: "200px" },
    { label: "Nome", key: "nome", width: "200px" },
    { label: "Ruolo", key: "tipo_utente", width: "120px" },
    { label: "Email", key: "username" },
    { 
      label: "Stato", 
      key: "abilitato_web",
      formatter: (value) => value == "1" ? "Attivo" : "In attesa" 
    },
  ];
}
